import React, {useEffect, useRef, useState} from "react";
import commonClose from "../../../assets/img/commonClose.png";
import commonInput from "../../../assets/img/commonInput.png";
import {useTranslation} from "react-i18next";
import axios from "../../../services/axiosInstance";
import {useLocation, useNavigate} from "react-router-dom";
import useTheme from "../layoutscommon/DarkModeStorage";
import "../../../css/web/UserModalRenew.css";

function EmailInputPopup({mbNum, joinMail, closeMailInputPopup, appleEmailPrivateFl, appleNamePrivateFl}) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const location = useLocation();
    const navigate = useNavigate()

    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [existsMailError, setExistsMailError] = useState(false);

    const [isSaveBtLoading, setIsSaveBtLoading] = useState(false);
    const [isSaveBtDisabled, setIsSaveBtDisabled] = useState(false);

    const handleEmailChange = (e) => { /* 두번 째 이메일 주소가 xx.xx가 아니면 에러메시지*/
        const emailRegex = /^[a-zA-Z0-9-ㄱ-힣]{2,25}@([\w-.]+)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3 }\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)$/;
        if (!e.target.value || emailRegex.test(e.target.value)) {
            setEmailError(false);
            setIsSaveBtDisabled(false);
        } else {
            setEmailError(true);
            setIsSaveBtDisabled(true);
        }
        setEmail(e.target.value);
    };

    const handleNameChange = ((e) => {
        const recnameRegex = /^[a-zA-Z ]{2,25}/; /*영문 2~25자*/
        if (!e.target.value || recnameRegex.test(e.target.value)) {
            setNameError(false);
            setIsSaveBtDisabled(false);
        } else {
            setNameError(true);
            setIsSaveBtDisabled(true);
        }
        setName(e.target.value);
    })

    const handleSubmit = () => {
        if (isSaveBtDisabled) {
            return;
        }
        setIsSaveBtDisabled(true);

        let changeMailFl = false;
        let changeNameFl = false;

        // 이메일만 변경
        if (appleEmailPrivateFl && !appleNamePrivateFl) {
            if (emailError || !email) {
                setEmailError(true);
                return;
            } else {
                changeMailFl = true;
            }
            // 성함만 변경
        } else if (!appleEmailPrivateFl && appleNamePrivateFl) {
            if (nameError || !name) {
                setNameError(true);
                return;
            } else {
                changeNameFl = true;
            }
            // 둘다 변경
        } else if (appleEmailPrivateFl && appleNamePrivateFl) {
            if (emailError || !email) {
                setEmailError(true);
                return;
            } else if (nameError || !name) {
                setNameError(true);
                return;
            } else {
                changeMailFl = true;
                changeNameFl = true;
            }
        }
        modifyMail(changeMailFl, changeNameFl);
    }

    const [saveComplMsg, setSaveComplMsg] = useState(false);
    const modifyMail = (changeMailFl, changeNameFl) => {
        try {
            setIsSaveBtLoading(true);
            axios({
                method: 'post',
                url: '/member/modifyMail',
                params: {
                    mbNum: mbNum,
                    email: email,
                    name: name,
                    appType: '0', // 0은 웹, 1은 앱
                    changeMailFl: changeMailFl,
                    changeNameFl: changeNameFl
                },
            })
                .then(async (response) => {
                    const data = response.data;
                    if (changeMailFl) {
                        if (data.loginErrorType === '0') {
                            setExistsMailError(true);
                            console.log('중복된 이메일입니다');
                            return;
                        }
                        localStorage.setItem('AToken', response.headers['authorization']);
                        /*
                         * 로그인 시각을 반드시 함께 남긴다.
                         * 없으면 App.js 의 토큰 점검이 '판단 불가' 로 보고 5분마다 재발급을
                         * 호출하게 되는데, 서버는 재발급 때마다 RT 를 교체하므로
                         * 불필요한 교체가 반복되고 탭이 여러 개면 RT 불일치로 세션이 죽는다.
                         */
                        localStorage.setItem('lastLoginTime', new Date().toISOString());
                    }
                    setSaveComplMsg(true);
                    setTimeout(() => closeMailInputPopup(), 2000);
                });
        } catch (error) {
            setIsSaveBtLoading(false);
            setIsSaveBtDisabled(false);
            console.log('error : ', error);
        } finally {
            setIsSaveBtLoading(false);
            setIsSaveBtDisabled(false);
        }
    };

    return (
        <div className="position-fixed wd-100pc ht-100pc display-flex just-cont-center align-center md-scope" data-theme={theme}
             style={{top: "0", left: "0", zIndex: 1000, background: "var(--md-backdrop, rgba(0, 0, 0, 0.3))"}}>
            <div className="wd-400"
                 style={{background: "var(--md-surface, white)", color: "var(--md-text)", boxShadow: "var(--md-shadow, 0 0 10px rgba(0, 0, 0, 0.5))", borderRadius: "14px"}}>
                <div className="wd-100pc"
                     style={{borderBottom: "solid 1px var(--md-border, #EAEAEA)", height: "70px", display: "flex", padding: "10px"}}>
                    <div className="display-flex align-center justify-content-between wd-100pc p-l-10 p-r-10">
                        <div className="user-center">
                            <div className="ht-100pc display-flex just-cont-center align-center">
                                <img className="wd-30 ht-30" alt='' src={commonInput}/>
                            </div>
                            <div style={{height: "100%", display: "flex", alignItems: "center"}}>
                                <p className="font-t-title font-s-18 m-t-2 m-l-10">{t('eipHd')}</p>
                            </div>
                        </div>
                        <div className="user-center ht-100pc">
                            <img className="wd-30 ht-30 m-a-opc-07 c-point" onClick={closeMailInputPopup}
                                 src={commonClose} alt="close"/>
                        </div>
                    </div>
                </div>

                {/*메일영역*/}
                {appleEmailPrivateFl ?
                    <div>
                        <div className="pd20">
                            <div
                                className="user-input-container wd-100pc ht-50 display-flex align-center just-cont-center">
                                <input onChange={(e) => handleEmailChange(e)} maxLength={50}
                                       onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                                       type="text"
                                       className="user-input wd-100pc ht-45 border-rd4 font-s-14 font-t-cont"
                                       style={{padding: "0 10px", color: "var(--md-text)"}} placeholder={t('umiPlaceHd1')}
                                       value={email}/>
                            </div>
                            {emailError ?
                                <div className="JoinErrorMsg font-t-cont m-t-10">
                                    <p className="JoinErrMsg">{t(`loginLabel1`)}</p>
                                </div>
                                :
                                null
                            }
                            {existsMailError ?
                                <div className="JoinErrorMsg font-t-cont m-t-10">
                                    <p className="JoinErrMsg">{t(`joinErr2`)}</p>
                                </div>
                                :
                                null
                            }
                        </div>
                        <div className="font-t-cont font-s-14 p-l-20 p-r-20 p-b-20">
                            <p>{t('eipLabel1')}</p>
                            <p>{t('eipLabel2')}</p>
                            <p>{t('eipLabel3')}</p>
                            <p className="m-t-10" style={{color: "#6499E1"}}>{t('eipLabel4')}</p>
                        </div>
                    </div>
                    :
                    null
                }

                {/*네임영역*/}
                {appleNamePrivateFl ?
                    <div>
                        <div className="p-l-20 p-r-20 p-b-20">
                            <div
                                className="user-input-container wd-100pc ht-50 display-flex align-center just-cont-center">
                                <input onChange={(e) => handleNameChange(e)} maxLength={35}
                                       onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                                       type="text"
                                       className="user-input wd-100pc ht-45 border-rd4 font-s-14 font-t-cont"
                                       style={{padding: "0 10px", color: "var(--md-text)"}} placeholder={t('joinLabel5')}
                                       value={name}/>
                            </div>
                            {nameError ?
                                <div className="JoinErrorMsg font-t-cont m-t-10">
                                    <p className="JoinErrMsg">{t('joinErr9')}</p>
                                </div>
                                :
                                null
                            }

                        </div>
                    </div>
                    :
                    null
                }

                { saveComplMsg ?
                <div className="JoinErrorMsg" style={{textAlign: "center"}}>
                    <p className="JoinErrMsg">{t(`eipTx1`)} &#128521;</p>
                </div>
                    :
                    null
                }

                <div className="display-flex just-cont-fend align-center pd20">
                    <button className="bt-btn-D-B font-s-15" style={{padding: "10px 20px"}}
                            onClick={closeMailInputPopup}>
                        <div>{t(`myPc15`)}</div>
                    </button>
                    {/*취소버튼*/}

                    <button className="bt-btn-B font-s-15 m-l-10" style={{padding: "10px 20px"}}
                            onClick={() => handleSubmit()} disabled={isSaveBtDisabled}>
                        {isSaveBtLoading ? (
                            <div className="spinner"></div>
                        ) : (
                            <div>{t(`saveBt`)}</div>
                        )}
                    </button>
                    {/*저장버튼*/}
                </div>

            </div>
        </div>
    )
}

export default EmailInputPopup